import { get, post } from './request'

export let listByType = (type, success, failure) => get(
  `api/categories/${type}/list`, success, failure
)

export let paginate = (path, success, failure) => {
  return get(
    `api${path}`, success, failure
  )
}

export let load = (category, success, failure) => get(
  `api/category/${category}`, success, failure
)

export let create = (category, type, success, failure) => post(
  `api/category/${type}/create`, category, success, failure
)

export let save = (category, success, failure) => post(
  `api/category/${category.id}/update`, category, success, failure
)

export let remove = (category, success, failure) => post(
  `api/category/${category}/remove`, {}, success, failure
)
